import { Insurance } from '../../lib/types/models/insurance/insurance'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getInsurance(id: number) {
  return restApiClient.url(constructApiUrl(API.insurances.get.url, { id })).get<Insurance>()
}
